<template lang="pug">
//- Card de prévia de um template de cupom ainda não ativado (tela de Marketing).
.cupomPreview(:class="{ 'cupomPreview--bloqueado': bloqueado }")
  .cupomPreview__badges
    span.cupomPreview__badge.cupomPreview__badge--destaque.Poppins(v-if="cupom.destaque == 1") ★ DESTAQUE
    span.cupomPreview__badge.cupomPreview__badge--primeiro.Poppins(v-if="cupom.primeiro_pedido_estabelecimento == 1") 1º PEDIDO
    span.cupomPreview__badge.cupomPreview__badge--inteligente.Poppins(v-if="cupom.inteligente") ✦ INTELIGENTE
  .cupomPreview__valor.Poppins
    span(v-if="cupom.taxa_entrega == 1 || cupom.entrega_gratis") Grátis
    span(v-else-if="cupom.tipo_desconto == 1") R${{ cupom.valor_desconto }}
    span(v-else) {{ cupom.valor_desconto }}%
  .cupomPreview__valor-label.Poppins
    span(v-if="cupom.taxa_entrega == 1 || cupom.entrega_gratis") NA ENTREGA
    span(v-else-if="cupom.tipo_desconto == 1") DE DESCONTO
    span(v-else) OFF NO PEDIDO
  .cupomPreview__regras.Poppins {{ regras }}
  v-btn.cupomPreview__cta.elevation-0.white--text.Poppins(
    block,
    :class="{ 'cupomPreview__cta--bloqueado': bloqueado }",
    @click="$emit('ativar', cupom)"
  )
    span(v-if="bloqueado") 🔒 Ativar cupom
    span(v-else) Ativar cupom
</template>

<script>
export default {
  name: 'CupomTemplateCard',
  props: {
    cupom: { type: Object, required: true },
    bloqueado: { type: Boolean, default: false },
  },
  computed: {
    regras() {
      const partes = [];
      if (this.cupom.tagline) {
        partes.push(this.cupom.tagline);
      } else {
        if (this.cupom.valor_minimo > 0) {
          partes.push(`Em pedidos acima de R$${this.cupom.valor_minimo}`);
        }
        if (this.cupom.valor_desconto_maximo) {
          partes.push(`Desconto máximo de R$${Number(this.cupom.valor_desconto_maximo).toFixed(2).replace('.', ',')}`);
        }
      }
      if (this.cupom.quantidade_usuario) {
        partes.push(`${this.cupom.quantidade_usuario}x por cliente`);
      }
      return partes.join(' · ');
    },
  },
};
</script>

<style lang="scss" scoped>
.cupomPreview {
  background: #fff;
  border: 1px solid #ECECEE;
  border-radius: 14px;
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 100%;
  min-height: 230px;
  transition: box-shadow 0.18s ease, transform 0.18s ease;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    transform: translateY(-2px);
  }

  &--bloqueado {
    opacity: 0.6;
    filter: grayscale(30%);
    &:hover {
      box-shadow: none;
      transform: none;
    }
  }

  &__badges {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    min-height: 20px;
  }
  &__badge {
    font-size: 9.5px;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 999px;
    letter-spacing: 0.3px;
    &--destaque    { background: #FBF1D3; color: #A8790A; }
    &--primeiro    { background: #E8E4FB; color: #5B4BC4; }
    &--inteligente { background: rgba(29, 154, 90, 0.12); color: #1d9a5a; }
  }
  &__valor {
    font-size: 28px;
    font-weight: 800;
    color: #1E2330;
    line-height: 1;
  }
  &__valor-label {
    font-size: 9px;
    letter-spacing: 0.08em;
    color: #9CA3AF;
    font-weight: 600;
  }
  &__regras {
    font-size: 11.5px;
    color: #4B5563;
    line-height: 1.4;
    min-height: 40px;
    flex: 1;
  }
  &__cta {
    background: #1E9E57 !important;
    border-radius: 9px !important;
    text-transform: none !important;
    font-weight: 600 !important;
    font-size: 13px !important;
    letter-spacing: 0 !important;
    height: 46px !important;
    margin: 0 !important;
    &--bloqueado {
      background: #E3E3E6 !important;
      color: #9CA3AF !important;
    }
  }
}
</style>
